export const catalog = {
    title: 'Catálogo',
    products: 'Produtos',
    categories: {
        title: 'Categorias',
        all: 'Todos',
        new: 'Drones Novos',
        used: 'Drones Usados',
        buffalo: 'Linha Buffalo',
        'power-citros': 'Power Citros',
        parts: 'Peças e Acessórios',
    },
    noProducts: 'Nenhum produto encontrado',
    noCategories: 'Nenhuma categoria encontrada',
    viewProduct: 'Ver produto',
    addToCart: 'Adicionar ao carrinho',
    productDetails: 'Detalhes do produto',
    description: 'Descrição',
    specifications: 'Especificações',
    reviews: 'Avaliações',
    relatedProducts: 'Produtos relacionados',
    searchPlaceholder: 'Buscar produtos...',
    filterBy: 'Filtrar por',
    sortBy: 'Ordenar por',
    clearFilters: 'Limpar Filtros',
    sortOptions: {
        priceAsc: 'Preço: menor para maior',
        priceDesc: 'Preço: maior para menor',
        nameAsc: 'Nome: A-Z',
        nameDesc: 'Nome: Z-A',
        newest: 'Mais recentes',
        oldest: 'Mais antigos',
    },
    results: {
        showing: 'Mostrando',
        of: 'de',
        results: 'resultados',
    },
    pagination: {
        ariaLabel: 'Navegação de páginas',
        previous: 'Anterior',
        next: 'Próxima',
        page: 'Página {{page}}',
    },
};
//# sourceMappingURL=catalog.js.map